import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0b5d2a86")
const _hoisted_1 = { class: "moves-table" }
const _hoisted_2 = { class: "moves-table__title" }
const _hoisted_3 = { class: "moves-table__table" }
const _hoisted_4 = { class: "moves-table__table-head" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "Move", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "Type", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "Category", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, "Power", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "Accuracy", -1)
const _hoisted_13 = { class: "moves-table__table-body" }
const _hoisted_14 = {
  key: 0,
  class: "moves-table__move-lvl"
}
const _hoisted_15 = {
  key: 1,
  class: "moves-table__move-tm"
}
const _hoisted_16 = {
  key: 2,
  class: "moves-table__move-tr"
}
const _hoisted_17 = { class: "moves-table__move-name" }
const _hoisted_18 = { class: "moves-table__move-type" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "moves-table__move-category" }
const _hoisted_21 = { class: "moves-table__move-power" }
const _hoisted_22 = { class: "moves-table__move-accuracy" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.tableLable), 1),
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", _hoisted_4, [
        _createElementVNode("tr", null, [
          (_ctx.variant === 'level-up')
            ? (_openBlock(), _createElementBlock("th", _hoisted_5, "Level"))
            : (_ctx.variant === 'tm')
              ? (_openBlock(), _createElementBlock("th", _hoisted_6, "TM"))
              : (_ctx.variant === 'tr')
                ? (_openBlock(), _createElementBlock("th", _hoisted_7, "TR"))
                : _createCommentVNode("", true),
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12
        ])
      ]),
      _createElementVNode("tbody", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableMoves, (move) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "moves-table__move",
            key: move.id
          }, [
            (move.lvl)
              ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(move.lvl), 1))
              : _createCommentVNode("", true),
            (move.tmNum)
              ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(move.tmNum), 1))
              : _createCommentVNode("", true),
            (move.trNum)
              ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(move.trNum), 1))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_17, _toDisplayString(move.name), 1),
            _createElementVNode("td", _hoisted_18, [
              _createElementVNode("div", {
                class: _normalizeClass(["app__type-pill", `app__type-pill--${move.type}`])
              }, [
                _createTextVNode(_toDisplayString(move.type) + " ", 1),
                _createElementVNode("img", {
                  class: "app__type-pill-icon",
                  src: _ctx.loadTypeImg(move.type),
                  alt: `${move.type} icon`
                }, null, 8, _hoisted_19)
              ], 2)
            ]),
            _createElementVNode("td", _hoisted_20, _toDisplayString(move.category), 1),
            _createElementVNode("td", _hoisted_21, _toDisplayString(move.power ? move.power : "/"), 1),
            _createElementVNode("td", _hoisted_22, _toDisplayString(move.accuracy ? move.accuracy : "/"), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}